import { CatalogListingTypeSchema } from "@redotech/redo-model/agents/ims-agents/listing-optimizable-fields";
import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum OptimizationStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  SKIPPED = "skipped",
}
export const OptimizationStatusSchema = createEnum(OptimizationStatus);

export const streamListingFieldOptimization = unaryStreamRpc({
  name: "streamListingFieldOptimization" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    listingType: CatalogListingTypeSchema,
    fields: z.array(z.string()),
  }),
  output: z.object({
    field: z.string(),
    status: OptimizationStatusSchema,
    originalValue: z.string().nullable(),
    optimizedValue: z.string().nullable(),
    allowWordAnimation: z.boolean(),
  }),
});
